/* eslint-disable react/no-array-index-key */
import Chip from '@/components/Chip/Chip'
import styles from './DishSummaryTile.module.scss'

type SummaryChip = {
  id: string
  label: string
  onDelete: () => void
}

interface DishSummaryTileProps {
  summaryTitle: string
  summaryChips: SummaryChip[]
}

function DishSummaryTile(props: DishSummaryTileProps) {
  const { summaryTitle, summaryChips } = props
  return (
    <div className={styles.dishSummaryTileWrapper}>
      <p className={`title-bold-medium ${styles.dishSummaryTileTitle}`}>
        {summaryTitle}
      </p>
      {summaryChips.length > 0 && (
        <div className={styles.dishSummaryTileChipsContainer}>
          {summaryChips.map((chip, index) => (
            <Chip
              key={`${chip.id}_${index}`}
              label={chip.label}
              color="primary"
              mobile
              onDelete={chip.onDelete}
            />
          ))}
        </div>
      )}
    </div>
  )
}
export default DishSummaryTile
